export enum SkuAnnotationLineStyle {
	Solid = 'solid',
	Dashed = 'dashed',
	Dotted = 'dotted'
}
